function bindInstanceEvent(instance, eventName, handler) {
  if (!instance || !instance.on) {
    return;
  }
  instance.on(eventName, handler);
}
function removeInstanceEvent(instance, eventName, handler) {
  if (!instance || !instance.off) {
    return;
  }
  instance.off(eventName, handler);
}

export { bindInstanceEvent, removeInstanceEvent };
//# sourceMappingURL=eventHelper.mjs.map
